<template>
    <div>
        {{$data}}
        <table id="detalle" class="table table-bordered table-responsive">
            <thead class="thead-dark">
                <tr>
                    <th v-for="column in columns">{{column}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td v-for="list in item">
                        <input type="text" v-model="list.value" :id="list.id" :name="list.name"/>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "tablaDetalleCrear",
        data(){
            return{
                columns:['Cód.Prov','Código','Descripción'
                    ,'Cantidad','Prec. Neto','Descuento','SubTotal'],
                item:[
                    { name: 'Cód.Prov', id: '1', value: ""},
                    { name: 'Código', id: '2', value: "" },
                    { name: 'Descripción', id: '3', value: "" },
                    { name: 'Cantidad', id: '4', value: "" },
                    { name: 'Prec. Neto', id: '5', value: "" },
                    { name: 'Descuento', id: '6', value: "" },
                    { name: 'SubTotal', id: '7', value: "" }
                    ],
            }
        },
        methods:{

        }
    }
</script>

<style scoped>
    input  {
        width: 100%;
    }
</style>
